/**
 * Candidate Portal Constants
 *
 * Centralized constants used across the candidate portal
 */

// Date formatting
export const DATE_FORMAT = 'DD/MM/YYYY';

// File paths
export const DISPUTE_FORM_URL = 'assets/files/acic_dispute_form.pdf';

// MIME types
export const PDF_MIME_TYPE = 'application/pdf';

// Check variant configurations
export const CHECK_VARIANTS = {
  actionRequired: {
    variant: 'orange',
    title: 'Action required',
    message:
      "Your report is ready to be reviewed. If everything looks good, you can choose to share it with your employer using Release to Client. You're not required to share the results. If you believe something is incorrect, select Dispute to raise an issue.",
  },
  releasedToClient: {
    variant: 'green',
    title: 'Report released',
    message:
      'You have released your report to your employer. You can download the report anytime from the portal.',
  },
  disputed: {
    variant: 'red',
    title: 'Report disputed',
    message:
      'We have received your dispute. We will review your request and get back to you shortly.',
  },
  ready: {
    variant: 'blue',
    title: 'Report ready',
    message: 'Your report is ready to review and download.',
  },
};

// Map variant names to Tailwind background classes
export const VARIANT_BG_CLASSES = {
  orange: 'bg-orange-1',
  green: 'bg-green-1',
  red: 'bg-red-1',
  blue: 'bg-blue-1',
};

// Map variant names to Tailwind text classes
export const VARIANT_TEXT_CLASSES = {
  orange: 'text-orange-3',
  green: 'text-green-3',
  red: 'text-red-3',
  blue: 'text-blue-3',
};
